// A single job posting, rendered from jobs.json by slug.

import React from 'react';
import { Bay, Btn, Eyebrow, Ticks } from '../primitives.jsx';
import { go } from '../routes.js';
import { jobs } from '../jobs.json';

export default function Job({ slug }) {
  const job = jobs.find((j) => j.slug === slug);
  if (!job) return null;

  return (
    <>
      <Bay band="ground">
        <Eyebrow>
          <a href="/careers" onClick={go('/careers')}>Careers</a>
        </Eyebrow>
        <h1 className="hddn-h1" style={{ marginTop: 18, maxWidth: '14ch' }}>{job.title}</h1>
        <p className="hddn-label" style={{ marginTop: 18, color: 'var(--ground-muted)' }}>{job.location}</p>
        <p className="hddn-lede" style={{ marginTop: 22, maxWidth: '54ch' }}>{job.intro}</p>
        <div style={{ marginTop: 28 }}>
          <Btn href={job.applyHref} variant="fill">Apply</Btn>
        </div>
      </Bay>

      <Bay narrow>
        {job.sections.map((s, i) => (
          <section key={s.heading} style={{ marginTop: i ? 'var(--gap)' : 0 }}>
            <h2 className="hddn-h3" style={{ marginBottom: 14 }}>{s.heading}</h2>
            <Ticks items={s.items} />
          </section>
        ))}
      </Bay>

      <Bay band="raised" narrow>
        <h2 className="hddn-h3">To apply</h2>
        <p className="hddn-lede" style={{ marginTop: 14, color: 'var(--ink)' }}>{job.apply}</p>
        <div style={{ marginTop: 24 }}>
          <Btn href={job.applyHref} variant="fill" wide>Apply</Btn>
        </div>
      </Bay>
    </>
  );
}
